module.exports = __webpack_public_path__ + "components/panel/static/affiliate_snow-forecast-12day-premium-da5f0691a052868e11b3dc3b62db80bf.png";